import SearchableSelect from '../../../components/ui/SearchableSelect/SearchableSelect';
import { mergeSlotProps } from '../../../components/ui/SearchableSelect/selectUtils';

export default function OnboardingSearchableSelect({ sx, slotProps, ...props }) {
  return (
    <SearchableSelect
      {...props}
      size={props.size || 'small'}
      sx={{ width: '100%', ...sx }}
      slotProps={mergeSlotProps(
        {
          paper: {
            sx: {
              mt: 0.5,
              borderRadius: 2,
            },
          },
        },
        slotProps
      )}
    />
  );
}
